import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://goldfish-app-28den.ondigitalocean.app/'
});

export default axiosInstance;
